import classes from './Chat.module.css'
import MessageLine from './messageLine/MessageLine';
import Transcript from './transcript/Transcript';
import Header from './header/Header'
import Sidebar from './sidebar/Sidebar';
import { useDispatch, useSelector } from 'react-redux';
import useBotsService from '../../services/bot/botService';
import { useEffect } from 'react';
import { toggle } from './sidebar/sidebarSlice';
import { useBotConfig } from '../../context/BotConfigContext';

function Chat() {
    const sidebarState = useSelector(state => state.sidebar)
    const botService = useBotsService()
    const isMobile = useSelector(state => state.layout).isMobile
    const dispatch = useDispatch()
    const config = useBotConfig()
    

    useEffect(() => {
        (async () => {
            const shouldLoadLastSession = config?.loadLastSession !== false; // default to true if not specified
            
            if (shouldLoadLastSession) {
                const sessions = await botService.syncSessions()
                const sessionCount = sessions?.length ?? 0
                console.log("sessions: " + sessionCount)
                if (sessionCount === 0) {
                    await botService.newSession()
                }
            } else {
                await botService.newSession()
            }
            
            if (isMobile) {
                dispatch(toggle({isOpen: false}))
            }
        })();
    }, [config?.botId, config?.loadLastSession, dispatch])

    let conversationClass = "Conversation"
    if (!sidebarState.isOpen) {
        conversationClass = "ConversationWide"
    }


    let converation = (
        <div className={classes[conversationClass]}>
            <Transcript/>
            <MessageLine/>
        </div> 
    )
    if (sidebarState.isOpen && isMobile) {
        converation = null
    }
    return (
        <div className={classes.Chat}>
            <Header/>
            <div className={classes.Content}>
                {converation}
                <Sidebar/>
            </div>
        </div>
    );
}

export default Chat;
